/// <amd-module name="Test/TestResultDetails/Actions/TestResultDetailsActionHub" />
import { Action } from "VSS/Reflux/Action";
import { ITestResultViewContextPayload, ITestDetailsPanePayload } from "Test/common-util/Contracts/ViewContracts";

export enum TestResultDetailsPanePivot {
    Debug = "debug",
    WorkItems = "work-items",
    Attachments = "attachments",
    History = "history"
}

export enum TestMode {
    TestResult,
    TestRun
}

export class TestResultDetailsActionHub {
    static readonly CHILD_SCOPE = "CHILD_SCOPE";
    public updateDetailsPane = new Action<ITestDetailsPanePayload>();
    public cleanDetailsPane = new Action<void>(TestResultDetailsActionHub.CHILD_SCOPE);
    public changeDetailsPivot = new Action<string>();
    public onResultsLoaded = new Action<ITestResultViewContextPayload>();
    public onError = new Action<string>();
    public captureHeaderState = new Action<boolean>();
}
